/**
 * @deprecated
 */
export const enum SubmitResult {
  ERROR = 'ERROR',
  NONE = 'NONE',
}

/**
 * @deprecated
 */
export const enum SubmitErrorType {
  NONE = 'NONE',
}

/**
 * @deprecated
 */
export type SubmitError = {
  type: SubmitErrorType
  claimId?: string
  details?: string
}

/**
 * @deprecated
 */
export const enum SubmitType {
  DEFAULT = 'DEFAULT',
  FIND_INSURANCE_MEMBER = 'FIND_INSURANCE_MEMBER',
}
